module.exports = __webpack_public_path__ + "static/img/brand1.d58e0b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/brand/brand1.png
// module id = LNQB
// module chunks = 1